import { createRouter, createWebHistory } from 'vue-router'
import CV from '../src/CV.vue'
import remoteOperation from '../src/RemoteOperation.vue' // your new page

const routes = [
  { path: '/CV', redirect:'/', name: 'CV', component: CV },
  { path: '/', name: 'CV2', component: CV },
  { path: '/remoteOperation', name: 'remoteOperation', component: remoteOperation }
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

export default router